













































import { log } from '@/log'
import { convertLongIdToShortId } from '@/models/api/id'
import { CurrentUser } from '@/services/api/current-user'
import AppId from '@/util/appid'
import { CookieService } from '@ajax/modules/cookie'
import { AppKind, Inquiry, InquiryKind, InquiryService, parseInquiryAppKind } from '@ajax/modules/services/inquiry'
import Util from '@ajax/modules/util'
import { ArrivalNotificationState } from '@ajax/vue/components/organisms/arrival/model/arrival-notification-state'
import { LineAccountAssociationUrlBuilder } from '@ajax/vue/components/organisms/arrival/model/line-account-association-url-builder'
import { ItemRequestResultModalEventHandler } from '@ajax/vue/components/templates/item-detail/model/modal-state'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import ArrivalRegister from './arrival/RegisterModal.vue'

@Component({
  components: {
    ArrivalRegister,
  },
})
export default class ArrivalNotification extends Vue {
  @Prop()
  inquiryKind: InquiryKind

  @Prop()
  /**
   * FIXME: 直接short idを受け取るようにする. long id も必要なら両方受け取る.
   * @see https://github.com/my-color/front/pull/6490#pullrequestreview-978069513
   */
  id: string

  @Prop({ required:true })
  brandEnglishName: string

  /** 表示後に遅延して情報を取得するのでnullable */
  @Prop({ required: true })
  isLineAccountAssociated: boolean | null

  @Prop({ default: false })
  lineAssociationLoadError: boolean

  @Prop({ default: false })
  useLargeButton: boolean

  loading: boolean = true
  state: ArrivalNotificationState = ArrivalNotificationState.empty()
  userInitializeError: boolean = false
  registerModalByMailIsOpen: boolean = false
  email: string = ''
  isRegisteredUser: boolean = false

  inquiryService: InquiryService
  userService: CurrentUser

  async created() {
    const appId = AppId.getByBrandName(this.brandEnglishName)
    this.inquiryService = new InquiryService(this.brandEnglishName)
    this.userService = new CurrentUser(appId)

    // ユーザーが本会員か確定してからstateを決定する必要があるので順序に注意
    await this.initializeIsRegisteredUser()
    await this.initializeState()
  }

  /**
   * FIXME:
   * idが変更されるたびにfetchUserInquiriesが実行される
   * したがってfetchUserInquiriesが完了する前に次のfetchUserInquiriesが実行される可能性があり、
   * 仮に順番が入れ替わって完了する（あとのPromiseが先に完了してしまう）と、UI上の選択状態と内部状態(state)が一致しない状態となる。
   * 根本的にはユーザーの登録済み情報は親（Restock.vue, Newstock.vueの呼び出し元）で取得、管理されるのが望ましい。
   *
   * 具体的には、カラコン商品詳細UIにおいてSKU1を選択してユーザーの商品リクエスト情報を取得している間に別のSKU2を選択するようなパターン
   * @see https://everforthgroup.slack.com/archives/C06QU5TTPS6/p1711728281149259
   */
  @Watch('id')
  async initializeState() {
    const alreadyRegistered = await this.fetchUserInquiries()
    this.state = ArrivalNotificationState.create(
      alreadyRegistered.map(inquiry => parseInquiryAppKind(inquiry)),
      this.inquiryKind,
      this.brandEnglishName
    )
    if (this.isRegisteredUser) {
      this.state = this.state.asRegisteredUser()
    }

    this.loading = false
  }

  async fetchUserInquiries(): Promise<Inquiry[]> {
    const response = await this.inquiryService.fetchUserInquiries(this.id, this.inquiryKind)

    if (response.isLeft()) {
      log.error(response.value)

      return []
    }

    return response.value
  }

  get buttonLabelForMail() {
    return this.state.getButtonLabelFor('mail')
  }

  get buttonLabelForLine(): string {
    return this.state.getButtonLabelFor('line')
  }

  get buttonClassForMail() {
    return {
      'c-btn': true,
      'c-btn--w-middle': !this.useLargeButton,
      'c-btn--w-full': this.useLargeButton,
      'c-btn--arrival-mail': true,
      'c-btn--arrival-mail--large': this.useLargeButton,
      'c-btn--disabled--middle': !this.canRequestInquiryByMail,
    }
  }

  get buttonClassForLine() {
    return {
      'c-btn': true,
      'c-btn--w-middle': !this.useLargeButton,
      'c-btn--w-full': this.useLargeButton,
      'c-btn--arrival-line': true,
      'c-btn--arrival-line--large': this.useLargeButton,
      'c-btn--disabled--middle': this.state.alreadyRegistered('line'),
    }
  }

  get canRequestInquiryByMail() {
    /**
     * 2023/06/15
     * 既存実装をそのまま引き継いでいるが、ゲストの場合は仮会員登録されるはずなので、
     * 基本的にこのコンポーネントにゲスト状態で来ることはないはず。
     * 初期実装時の名残かもしれないので不要であれば削除したい。
     */
    const isGuest: boolean = Util.isGuest()

    return isGuest || !this.state.alreadyRegistered('mail')
  }

  get shortId(): string {
    return convertLongIdToShortId(this.id)
  }

  get allowEmail(): boolean {
    return this.state.allow('mail')
  }

  get allowLine(): boolean {
    return this.state.allow('line')
  }

  /**
   * TODO: propで親から渡してもらうのが良さそう
   */
  async initializeIsRegisteredUser() {
    if (!CookieService.isLogined()) {
      return
    }

    const user = await this.userService.getCurrentUser()

    if (user.isLeft()) {
      this.userInitializeError = true

      return
    }

    if (user.value.user_status === 'registered') {
      this.isRegisteredUser = true
    }
  }

  async onClickLine() {
    if (this.isLineAccountAssociated === null) {
      log.debug('not initialized isLineAccountAssociated')

      return
    }
    if (this.state.alreadyRegistered('line')) {
      return
    }

    if (this.lineAssociationLoadError) {
      ItemRequestResultModalEventHandler.getInstance().open({
        style: 'error',
        heading: 'エラー',
        messages: ['LINEアカウント連携情報の取得に失敗しました。'],
        onClose: () => location.reload(),
      })

      return
    }

    if (!this.isLineAccountAssociated) {
      location.href = new LineAccountAssociationUrlBuilder(
        location.pathname,
        this.brandEnglishName,
        this.id,
        this.inquiryKind
      ).build()

      return
    }

    await this.registerByLine()
  }

  @Emit('toggle')
  async onClickMail() {
    if (!this.canRequestInquiryByMail) {
      return
    }

    if (this.state.isRegisteredUser) {
      await this.registerByMail()

      return
    }

    /**
     * 2023-06-28メモ
     * 既存実装のままユーザー情報の取得に失敗したらモーダルを開かないようにしているが、
     * むしろモーダルを開いてメールアドレスを入力or空メールで登録してもらったほうが良いのではないかという疑念がある。
     */
    if (this.userInitializeError) {
      return
    }

    this.registerModalByMailIsOpen = true
  }

  @Emit('toggle')
  closeRegisterModalByMail() {
    this.registerModalByMailIsOpen = false
  }

  async submitRegisterByMail() {

    const validated = await this.validateForm()
    if (!validated) return

    this.registerByMail()

    this.registerModalByMailIsOpen = false
  }

  async registerByMail() {
    this.register('mail', 'メール')
  }

  async registerByLine() {
    this.register('line', 'LINE')
  }

  async register(appKind: AppKind, appLabel: string) {
    const shouldQueryEmail = appKind === 'mail' && !this.state.isRegisteredUser
    const response = await this.inquiryService.register({
      sku_id: this.id,
      inquiry_kind: this.inquiryKind,
      app_kind: appKind,
      ...shouldQueryEmail ? { email: this.email } : {},
    })

    const modalEventHandler = ItemRequestResultModalEventHandler.getInstance()
    response.fold(
      () => {
        modalEventHandler.open({
          style: 'error',
          heading: 'エラー',
          messages: [
            'しばらくしてから、再度お試しください。',
            '改善されない場合は、カスタマーセンターまでお問い合わせください。',
          ],
        })
      },
      () => {
        this.state = this.state.addSuccessfullyRegistered(appKind)
        modalEventHandler.open({
          style: 'success',
          heading: 'お知らせ設定完了',
          messages: [
            `商品が入荷されたら${appLabel}でお知らせします。`,
          ],
        })
      }
    )
  }

  async validateForm(): Promise<boolean> {

    return this.$validator.validateAll()
  }

  @Emit('toggle')
  openMailer() {
    this.state = this.state.addSuccessfullyRegistered('mail')
    this.registerModalByMailIsOpen = false
  }
}
